/** Whether a person is salaried or paid per shift. */
export default function StaffTypeBadge({ isSalaried }: { isSalaried: boolean }) {
  return (
    <span
      className={`text-xs px-2 py-0.5 rounded border ${
        isSalaried
          ? 'bg-purple-50 dark:bg-purple-900/20 text-purple-700 dark:text-purple-300 border-purple-200 dark:border-purple-800'
          : 'bg-stone-50 dark:bg-[#1e2520] text-stone-700 dark:text-stone-300 border-stone-200 dark:border-stone-700'
      }`}
    >
      {isSalaried ? 'Salaried' : 'Per shift'}
    </span>
  );
}
